import "./styles/index.scss";

import { useTimer } from "@/hooks/useCountDown";
import { FC, useEffect, useState } from "react";
import { Heading } from "@radix-ui/themes";

import { Logitech_custom_Racing_meta } from "./components/customClientStates/Logitech_custom_Racing_meta";
import { RacingDisclaimer } from "./components/Racing_disclaimer";
import { leaderboardRenderer } from "./utils/leaderboardRenderer";
import { brand } from "../../brandVariables/getBandVariables";
import { ClientProps } from "../../hooks/useClientData";
import { Racing_meta } from "./components/Racing_meta";
import { RACINGEndScreen } from "./RACING_endScreen";
import { BrandLogo } from "../reusable/brandLogo";

export const RACINGLeaderboard: FC<{
  clientData: ClientProps;
}> = ({ clientData }) => {
  const hasActiveChallenge =
    clientData.leaderboard.data && !clientData.leaderboard.loading;

  const hasActiveChallengeData =
    clientData.hasActiveChallenge && clientData.leaderboard.data;

  const isElgiganten = brand.client === "elgiganten-9u2oj" ? "text-gradient" : "";

  const { time, isTimeOver, clearTimer } = useTimer(
    clientData.challenge.data?.endDate || undefined
  );

  const [hasRanAlternate, setHasRanAlternate] = useState<boolean>(false);
  const [alternateState, setAlternateState] = useState<number>(0);

  let intervalId;
  let index = 0;

  const startInterval = () => {
    intervalId = setInterval(() => {
      setHasRanAlternate(true);
      if (index === 1) {
        index = 0;

        return setAlternateState(0);
      } else if (index === 0) {
        index = 1;
        return setAlternateState(1);
      }
    }, 15000); // 30 seconds
  };

  useEffect(() => {
    if (!hasRanAlternate && clientData?.winners?.data.length !== 0) {
      console.log("starting interval");
      startInterval();
    }
  }, []);

  const leaderboardLength = clientData.leaderboard.length as number;
  // const leaderboardLength = 3 as number;
  const [endScreen, setEndScreen] = useState<boolean>(false);

  useEffect(() => {
    if (!clientData.nextChallenges.loading && isTimeOver) {
      if (
        isTimeOver &&
        (!clientData.nextChallenges.data ||
          clientData.nextChallenges.data?.length === 0)
      ) {
        if (
          !clientData?.challenge?.data ||
          clientData.challenge.data.status === "finished"
        ) {
          setEndScreen(true);
          clearTimer();
        }
      }
    }
  }, [time, isTimeOver, clientData]);

  if (endScreen) {
    clearInterval(intervalId);
    index = 10;
    return <RACINGEndScreen clientData={clientData} />;
  }

  if (alternateState === 1) {
    clearInterval(intervalId);
    return <RACINGEndScreen clientData={clientData} />;
  }

  return (
    <>
      {/* IF ACTIVE CHALLENGE*/}
      {hasActiveChallengeData && (
        <>
          <div className={`overview ${leaderboardLength === 0 ? "empty" : ""}`}>
            <div className="overview__heading">
              <section>
                <div className="heading">
                  <Heading as="h1">{brand.content.generalHeadline}</Heading>
                  {(brand.prize.nameOf || brand.prize.content) && (
                    <Heading as="h2">
                      {brand.prize.content}{" "}
                      <span className={isElgiganten}>
                        {" "}
                        {brand.prize.nameOf}
                      </span>{" "}
                      {brand.client === "logitechg-7vvzz" && "From lego"}
                    </Heading>
                  )}
                </div>

                {hasActiveChallenge && (
                  <div className="brand-logo">
                    <BrandLogo />
                  </div>
                )}
              </section>
            </div>

            <div
              className={`overview__content ${leaderboardLength === 0 ? "empty" : ""
                } ${leaderboardLength > 3 ? "full" : ""}`}
            >
              <section className="leaderboard">
                {leaderboardRenderer({
                  leaderboardLength,
                  clientData,
                })}
              </section>

              {leaderboardLength !== 0 && (
                <section>
                  {brand.client === "logitechg-7vvzz" ? (
                    <Logitech_custom_Racing_meta clientData={clientData} />
                  ) : (
                    <Racing_meta clientData={clientData} />
                  )}
                </section>
              )}
            </div>

            {RacingDisclaimer()}
          </div>
        </>
      )}
    </>
  );
};
